<br clear="both"/>
<app-progressbar *ngIf="showSpinner"></app-progressbar>
<div *ngIf="!showSpinner && projectEdasAlarms.length > 0" >
<div  class="header">
  <b [innerHtml]="'EDAS_ALARMS'|translate">Information</b>
</div>
<br clear="both"/>
<div *ngFor="let edasAlarms of projectEdasAlarms" class="box">
  <app-edas-alarms [edasAlarms]="edasAlarms"></app-edas-alarms>
  <br clear="both"/>
</div>
</div>
